import * as React from 'react';

function SvgAddCircleFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <path d="M16 2a14 14 0 1014 14A14 14 0 0016 2zm6 15h-5v5h-2v-5h-5v-2h5v-5h2v5h5z" />
    </svg>
  );
}

export default SvgAddCircleFilled;
